import Vue from 'vue';
import Vuex from 'vuex';

// Contact and Careers
import contact from './modules/contact';
import careers from './modules/careers';
import cases from './modules/cases';
import articles from './modules/blog';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    contact,
    careers,
    cases,
    articles
  },

  strict: process.env.NODE_ENV !== 'production'

});



// WEBPACK FOOTER //
// src/store/index.js